import baseapi from "../baseAPI";

export const DispositionListAPI = async (setDispositionList, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/disposition?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log('Data===='+response.data.data.data);
        setDispositionList(response.data.data.data);
        setLoading(false);

        //console.log('length====' + response.data.data.data.length);
        if(response.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

